import { connect } from "react-redux";
import TrendToggle from "./TrendToggle";

// The two lookups are subscribed to here rather than a level up on purpose: one
// of them landing then re-renders the toggle alone, leaving the picker beneath
// it — which arrives as children — as it was.
const mapStateToProps = (state) => {
    const { fetchSurveyLists, fetchOrgRaterGroupsApi, hasVisualizationResponse, isLeaderGateNotMet } = state.BenchmarkFilteringReducer;
    return {
        fetchSurveyLists,
        fetchOrgRaterGroupsApi,
        // Both halves are needed: the gate flag is false before anything has
        // come back as well as when the gate is met, so on its own it would
        // offer the comparison for a dataset that is about to be found too
        // small. A boolean, so a section's data landing doesn't re-render this.
        isLeaderGateMet: hasVisualizationResponse && !isLeaderGateNotMet,
    };
};

export default connect(mapStateToProps)(TrendToggle);
